import React, { FC } from 'react';

export const LayoutEmpty: FC = ({ children }) => {
  return <>{children}</>;
};
